export default __webpack_public_path__ + "static/media/Mark-6-HUD-01.444a8d1e.jpg";